import { useCallback, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import Grid from "@mui/material/Grid";
import Card from "@mui/material/Card";
import CardMedia from "@mui/material/CardMedia";
import CardContent from "@mui/material/CardContent";
import Chip from "@mui/material/Chip";

import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import MDButton from "components/MDButton";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import Footer from "examples/Footer";
import api from "services/api";
import { requireAuth } from "actions/AuthAction";
import { resolveUploadUrl } from "utils";
import GaleriFormDialog from "./components/GaleriFormDialog";

function AdminGaleriAktivitas() {
  const navigate = useNavigate();
  const [rows, setRows] = useState([]);
  const [loading, setLoading] = useState(true);
  const [formOpen, setFormOpen] = useState(false);
  const [formMode, setFormMode] = useState("create");
  const [selectedItem, setSelectedItem] = useState(null);

  const loadData = useCallback(() => {
    setLoading(true);
    api
      .get("galeri-aktivitas")
      .then((res) => setRows(res.data?.data || []))
      .catch((error) => {
        const status = error.response?.status;
        const message = error.response?.data?.message;
        alert(
          `Gagal memuat galeri aktivitas${status ? ` (status ${status})` : ""}.${message ? ` ${message}` : ""} Pastikan backend TIALAI sudah di-restart.`
        );
      })
      .finally(() => setLoading(false));
  }, []);

  useEffect(() => {
    if (!requireAuth(navigate, ["ADMIN", "SUPER_ADMIN"])) return undefined;
    loadData();
    return undefined;
  }, [navigate, loadData]);

  const openCreate = () => {
    setFormMode("create");
    setSelectedItem(null);
    setFormOpen(true);
  };

  const openEdit = (item) => {
    setFormMode("edit");
    setSelectedItem(item);
    setFormOpen(true);
  };

  const handleDelete = async (item) => {
    if (!window.confirm(`Hapus foto "${item.caption}"?`)) return;
    try {
      await api.delete(`galeri-aktivitas/${item.id}`);
      loadData();
    } catch (error) {
      alert(error.response?.data?.message || "Gagal menghapus foto");
    }
  };

  return (
    <DashboardLayout>
      <DashboardNavbar />
      <MDBox py={3}>
        <MDBox display="flex" justifyContent="space-between" alignItems="center" mb={3}>
          <MDBox>
            <MDTypography variant="h4" fontWeight="medium">
              Galeri Aktivitas
            </MDTypography>
            <MDTypography variant="button" color="text">
              Kelola foto dan caption yang tampil di landing page
            </MDTypography>
          </MDBox>
          <MDButton variant="gradient" color="info" onClick={openCreate}>
            Tambah Foto
          </MDButton>
        </MDBox>

        {loading ? (
          <MDTypography>Memuat...</MDTypography>
        ) : rows.length === 0 ? (
          <MDTypography color="text">Belum ada foto aktivitas.</MDTypography>
        ) : (
          <Grid container spacing={3}>
            {rows.map((item) => (
              <Grid item xs={12} sm={6} md={4} key={item.id}>
                <Card sx={{ height: "100%" }}>
                  <CardMedia
                    component="img"
                    height="200"
                    image={resolveUploadUrl(item.file_url)}
                    alt={item.caption}
                    sx={{ objectFit: "cover" }}
                  />
                  <CardContent>
                    <MDBox display="flex" justifyContent="space-between" alignItems="flex-start" mb={1}>
                      <Chip
                        label={item.status}
                        size="small"
                        color={item.status === "AKTIF" ? "success" : "default"}
                      />
                      <MDTypography variant="caption" color="text">
                        Urutan: {item.urutan}
                      </MDTypography>
                    </MDBox>
                    <MDTypography variant="button" color="text" fontWeight="regular" mb={2}>
                      {item.caption}
                    </MDTypography>
                    <MDBox display="flex" gap={1}>
                      <MDButton size="small" variant="outlined" color="info" onClick={() => openEdit(item)}>
                        Edit
                      </MDButton>
                      <MDButton size="small" variant="outlined" color="error" onClick={() => handleDelete(item)}>
                        Hapus
                      </MDButton>
                    </MDBox>
                  </CardContent>
                </Card>
              </Grid>
            ))}
          </Grid>
        )}
      </MDBox>
      <Footer />

      <GaleriFormDialog
        open={formOpen}
        mode={formMode}
        item={selectedItem}
        onClose={() => setFormOpen(false)}
        onSaved={loadData}
      />
    </DashboardLayout>
  );
}

export default AdminGaleriAktivitas;
